import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const LinkIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <path
        d="M19.2 10.584a1.2 1.2 0 0 0-1.2 1.2V20.4a1.2 1.2 0 0 1-1.2 1.2H3.6a1.2 1.2 0 0 1-1.2-1.2V7.2A1.2 1.2 0 0 1 3.6 6h8.616a1.2 1.2 0 1 0 0-2.4H3.6A3.6 3.6 0 0 0 0 7.2v13.2A3.6 3.6 0 0 0 3.6 24h13.2a3.6 3.6 0 0 0 3.6-3.6v-8.616a1.2 1.2 0 0 0-1.2-1.2zm4.704-9.84a1.2 1.2 0 0 0-.648-.648A1.2 1.2 0 0 0 22.8 0h-7.2a1.2 1.2 0 1 0 0 2.4h4.308L7.548 14.748a1.2 1.2 0 0 0 0 1.704 1.2 1.2 0 0 0 1.704 0L21.6 4.092V8.4a1.2 1.2 0 1 0 2.4 0V1.2a1.2 1.2 0 0 0-.096-.456z"
        fillRule="evenodd"
      />
    </svg>
  )
})
